export const horizontalAlignments = [
  [
    "",
    ""
  ],
  [
    "left",
    "Left"
  ],
  [
    "center",
    "Center"
  ],
  [
    "right",
    "Right"
  ],
  [
    "stretch",
    "Stretch"
  ]
]

export const verticalAlignments = [
  [
    "",
    ""
  ],
  [
    "top",
    "Top"
  ],
  [
    "middle",
    "Middle"
  ],
  [
    "bottom",
    "Bottom"
  ],
  [
    "stretch",
    "Stretch"
  ]
]